import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/components/modals/modal.service';
import { RvSortableItem, RvSortableService } from 'src/app/rv-sortable';
import { BroadcasterService } from 'src/app/shared/services/broadcaster.service';
import { PlaceholderPlaylistService } from '../../services/placeholder-playlist.service';
import { PlaylistItemService } from '../../services/playlist-item.service';
import { SettingsService } from '../../services/settings.service';
import { WidgetUtilsService } from '../../services/widget-utils.service';

interface PlaylistItem extends RvSortableItem {
  id: string;
  name: string;
  type: string;
  duration: number;
  playUntilDone?: boolean;
  objectReference?: string;
  settingsUrl?: string;
}

@Component({
  selector: 'placeholder-playlist',
  templateUrl: './placeholder-playlist.component.html',
  styleUrls: ['./placeholder-playlist.component.scss'],
  standalone: false,
})
export class PlaceholderPlaylistComponent implements OnInit, OnDestroy {
  sortableService: RvSortableService<PlaylistItem>;
  subscription: Subscription;

  constructor(
    private modalService: ModalService,
    private broadcaster: BroadcasterService,
    public placeholderPlaylistService: PlaceholderPlaylistService,
    public playlistItemService: PlaylistItemService,
    private settingsService: SettingsService,
    public widgetUtils: WidgetUtilsService,
    private host: ElementRef,
  ) {}

  ngOnInit() {
    this.subscription = this.broadcaster.on('placeholderSet', () => {
      this.sortableService = new RvSortableService<PlaylistItem>({
        items: this.placeholderPlaylistService.getItems(),
        getDisplayName: (item) => item.name,
        onReorder: () => this.handleReorder(),
        afterPositionChanged: () => this.handleReorder(),
        hostElement: this.host,
        appendTo: '.workspace-sidebar',
      });
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getDurationTooltip(item) {
    var msg = 'Duration: ';
    if (item.playUntilDone) {
      msg += 'Play Until Done';
    } else {
      msg += item.duration + ' seconds';
    }
    return msg;
  }

  remove(item) {
    this.modalService
      .confirmDanger(
        'Remove Item',
        'Are you sure you want to remove this Widget from the Playlist?',
        'Remove',
      )
      .then(() => {
        this.placeholderPlaylistService.removeItem(item);
      });
  }

  private handleReorder(): void {
    this.broadcaster.emit('placeholderUpdated');
  }

  sortItem(evt) {
    var oldIndex = evt.data.oldIndex;
    var newIndex = evt.data.newIndex;

    this.placeholderPlaylistService.moveItem(oldIndex, newIndex);

    this.broadcaster.emit('placeholderUpdated');
  }

  showSettingsModal(item) {
    this.settingsService.showSettingsModal(item);
  }

  isEditable(item) {
    if (item.type === 'widget' && (item.objectReference || item.settingsUrl)) {
      return true;
    } else if (item.type === 'presentation') {
      return true;
    } else {
      return false;
    }
  }
}
